var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9C16.5 11.4853 14.4853 13.5 12 13.5C9.51472 13.5 7.5 11.4853 7.5 9C7.5 6.51472 9.51472 4.5 12 4.5C14.4853 4.5 16.5 6.51472 16.5 9ZM15.9139 14.19C17.4848 13.0035 18.5 11.1203 18.5 9C18.5 5.41015 15.5899 2.5 12 2.5C8.41015 2.5 5.5 5.41015 5.5 9C5.5 11.1203 6.51523 13.0035 8.08611 14.19C7.22211 14.5129 6.43147 14.9411 5.74315 15.4574C4.10601 16.6852 3 18.4578 3 20.5C3 21.0523 3.44772 21.5 4 21.5C4.55228 21.5 5 21.0523 5 20.5C5 19.2285 5.68486 18.0011 6.94315 17.0574C8.20174 16.1134 9.98631 15.5 12 15.5C14.0137 15.5 15.7983 16.1134 17.0569 17.0574C18.3151 18.0011 19 19.2285 19 20.5C19 21.0523 19.4477 21.5 20 21.5C20.5523 21.5 21 21.0523 21 20.5C21 18.4578 19.894 16.6852 18.2569 15.4574C17.5685 14.9411 16.7779 14.5129 15.9139 14.19Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Profile.aec4ab25.svg";
export { ForwardRef as ReactComponent };